import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getComponentClasses } from '@99designs/common/utils/app';

class StickyElement extends Component {
    constructor(props) {
        super();

        this.recalculate = this.recalculate.bind(this);

        this.state = {
            sticky: false,
            width: null,
            height: null,
        };
    }

    componentDidMount() {
        window.addEventListener('touchmove', this.recalculate);
        window.addEventListener('scroll', this.recalculate);
        window.addEventListener('resize', this.recalculate);
    }

    componentWillUnmount() {
        window.removeEventListener('touchmove', this.recalculate);
        window.removeEventListener('scroll', this.recalculate);
        window.removeEventListener('resize', this.recalculate);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props !== nextProps ||
            this.state.sticky != nextState.sticky ||
            this.state.width != nextState.width ||
            this.state.height != nextState.height
        );
    }

    recalculate() {
        const bounds = this.node.getBoundingClientRect();
        const scrollTop = document.body.scrollTop;
        const componentOffsetTop = bounds.top + scrollTop;
        const customOffsetTop = this.props.offsetTop;
        const shouldStick = scrollTop >= componentOffsetTop - customOffsetTop - 1; // -1px to handle scrollTo situations

        this.setState({
            sticky: shouldStick,
            height: this.contentNode.clientHeight,
            width: this.contentNode.clientWidth,
        });
    }

    renderPlaceholder() {
        const { sticky, width, height } = this.state;

        if (sticky) {
            return <div className="sticky-element__placeholder" style={{ width, height }} />;
        }

        return null;
    }

    getViewportHeight() {
        return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }

    getStyles() {
        const { fillViewportHeight, offsetTop } = this.props;
        const { sticky, width } = this.state;
        const stickyStyles = {
            width: width,
            position: 'fixed',
            top: offsetTop,
            zIndex: 2,
        };

        if (sticky) {
            if (fillViewportHeight) {
                return Object.assign({}, stickyStyles, {
                    overflowY: 'auto',
                    maxHeight: this.getViewportHeight(),
                });
            }

            return stickyStyles;
        }

        return null;
    }

    render() {
        const { children, variations } = this.props;
        const { sticky } = this.state;
        const classes = getComponentClasses('sticky-element', variations);

        return (
            <div className={classes} ref={node => (this.node = node)} data-sticky={sticky}>
                {this.renderPlaceholder()}

                <div
                    className="sticky-element__content"
                    ref={node => (this.contentNode = node)}
                    style={this.getStyles()}
                >
                    {children}
                </div>
            </div>
        );
    }
}

StickyElement.propTypes = {
    children: PropTypes.node.isRequired,
    offsetTop: PropTypes.number,
    fillViewportHeight: PropTypes.bool,
    variations: PropTypes.array,
};

StickyElement.defaultProps = {
    fillViewportHeight: false,
    offsetTop: 0,
    variations: [],
};

export default StickyElement;
